import 'core-js/stable'
import Vue from 'vue'
import CoreuiVue from '@coreui/vue'
import App from './App'
import { store } from '@/store';
import { router } from '@/router';
import apolloProvider from '@/apollo'
import * as helpers from '@/helpers'

import { uimixin } from '@/uimixin'

import { iconsSet as icons } from './assets/icons/icons.js'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// import the component
// https://vue-treeselect.js.org/
import Treeselect from '@riophae/vue-treeselect'
Vue.component('treeselect', Treeselect)

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
Vue.component('daterangepicker', DateRangePicker)

import VCalendar from 'v-calendar';

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  // componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />

});
// import CKEditor from '@ckeditor/ckeditor5-vue2';
// Vue.use( CKEditor );

import VueMoment from 'vue-moment';
import Vue2Filters from 'vue2-filters'
import resize from "vue-element-resize-detector";
import VueTruncate from 'vue-truncate-filter';
import Print from 'vue-print-nb'
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg);

Vue.use(Print);

Vue.use(CoreuiVue)
Vue.use(resize)

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueMoment);
Vue.use(Vue2Filters)
Vue.use(VueTruncate)

Vue.component('AutoLogout', () => import('@/pages/private/AutoLogout'));

// Vue.component('Report', () => import('@/pages/private/Apps/Reports/Components/Report'));
Vue.component('Report1', () => import('@/pages/private/Apps/Reports/Components/Report1'));

// Vue.component('Flextable', () => import('@/pages/components/Flextable.vue'));
Vue.component('Sidebardocuments', () => import('@/pages/components/Sidebardocuments.vue'));

Vue.component('TileAdd', () => import('@/pages/private/Tiles/TileAdd'));
Vue.component('TileSettings', () => import('@/pages/private/Tiles/TileSettings'));

// Vue.component('DailySearch', () => import('@/pages/private/Tiles/DailySearch'));
// Vue.component('SearchTraffic', () => import('@/pages/private/Tiles/SearchTraffic'));
// Vue.component('RepositoryFeed', () => import('@/pages/private/Tiles/RepositoryFeed'));

Vue.component('UpNext', () => import('@/pages/private/Tiles/UpNext'));
Vue.component('SabrePNRStatus', () => import('@/pages/private/Tiles/SabrePNRStatus'));
Vue.component('StorePNRStatus', () => import('@/pages/private/Tiles/StorePNRStatus'));
Vue.component('ETRPChart', () => import('@/pages/private/Tiles/ETRPChart'));
Vue.component('ETRPStatus', () => import('@/pages/private/Tiles/ETRPStatus'));
Vue.component('TickNIChart', () => import('@/pages/private/Tiles/TickNIChart'));
Vue.component('Welcome', () => import('@/pages/private/Tiles/Welcome'));
Vue.component('Welcome1', () => import('@/pages/private/Tiles/Welcome1'));
Vue.component('CarFutures', () => import('@/pages/private/Tiles/CarFutures'));
Vue.component('CarUninvoiced', () => import('@/pages/private/Tiles/CarUninvoiced'));
Vue.component('CarBookChart', () => import('@/pages/private/Tiles/CarBookChart'));
Vue.component('CarStats', () => import('@/pages/private/Tiles/CarStats'));
Vue.component('HotelUninvoiced', () => import('@/pages/private/Tiles/HotelUninvoiced'));
Vue.component('HotelStats', () => import('@/pages/private/Tiles/HotelStats'));
Vue.component('OrderChart', () => import('@/pages/private/Tiles/OrderChart'));
Vue.component('OrderUninvoiced', () => import('@/pages/private/Tiles/OrderUninvoiced'));
Vue.component('OrderStats', () => import('@/pages/private/Tiles/OrderStats'));
Vue.component('OrderDonuts', () => import('@/pages/private/Tiles/OrderDonuts'));
Vue.component('OrderPlaced', () => import('@/pages/private/Tiles/OrderPlaced'));
Vue.component('BankingCards', () => import('@/pages/private/Tiles/BankingCards'));

Vue.component('d-table', () => import('@/pages/components/d-table.vue'));
Vue.component('e-table', () => import('@/pages/components/e-table.vue'));
Vue.component('r-table', () => import('@/pages/components/r-table.vue'));
Vue.component('r-invoice', () => import('@/pages/components/r-invoice.vue'));

Vue.component('i-loaderbl', () => import('@/pages/components/i-loaderbl.vue'));

// E-TABLE COMPONENTS
Vue.component('i-cinvoice', () => import('@/pages/private/Apps/Invoicing/Components/i-cinvoice.vue'));
Vue.component('i-linvoice', () => import('@/pages/private/Apps/Invoicing/Components/i-linvoice.vue'));
Vue.component('i-binvoice', () => import('@/pages/private/Apps/Invoicing/Components/i-binvoice.vue'));
Vue.component('i-zinvoice', () => import('@/pages/private/Apps/Invoicing/Components/i-zinvoice.vue'));
Vue.component('i-zinvoiceOLD', () => import('@/pages/private/Apps/Invoicing/Components/i-zinvoiceOLD.vue'));
Vue.component('i-ginvoice', () => import('@/pages/private/Apps/Invoicing/Components/i-ginvoice.vue'));
Vue.component('i-xinvoice', () => import('@/pages/private/Apps/Invoicing/Components/i-xinvoice.vue'));
Vue.component('i-tinvoice', () => import('@/pages/private/Apps/Invoicing/Components/i-tinvoice.vue'));


Vue.component('i-reconcile', () => import('@/pages/components/i-reconcile.vue'));

Vue.component('Pastespecial', () => import('@/pages/components/Pastespecial.vue'));
Vue.component('NotesEdit', () => import('@/pages/components/NotesEdit.vue'));
Vue.component('t-wizard', () => import('@/pages/components/t-wizard.vue'));
Vue.component('t-clipboard', () => import('@/pages/components/t-clipboard.vue'));
Vue.component('t-slidegroup', () => import('@/pages/components/t-slidegroup.vue'));

Vue.component('vc-single', () => import('@/pages/components/vc-single.vue'));
Vue.component('vc-range', () => import('@/pages/components/vc-range.vue'));
Vue.component('b-2fa', () => import('@/pages/components/b-2fa.vue'));

// Filters
Vue.filter('formatSize', function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB'
  }
  return size.toString() + ' B'
})
Vue.filter('formatTimeago', function (time) {
  switch (typeof time) {
    case 'number':
      break;
    case 'string':
      time = +new Date(time);
      break;
    case 'object':
      if (time.constructor === Date) time = time.getTime();
      break;
    default:
      time = +new Date();
  }
  var time_formats = [
    [60, 'seconds', 1], // 60
    [120, '1 minute ago', '1 minute from now'], // 60*2
    [3600, 'minutes', 60], // 60*60, 60
    [7200, '1 hour ago', '1 hour from now'], // 60*60*2
    [86400, 'hours', 3600], // 60*60*24, 60*60
    [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
    [604800, 'days', 86400], // 60*60*24*7, 60*60*24
    [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
    [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
    [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
    [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
    [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
    [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
    [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
    [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
  ];
  var seconds = (+new Date() - time) / 1000,
    token = 'ago',
    list_choice = 1;

  if (seconds == 0) {
    return 'Just now'
  }
  if (seconds < 0) {
    seconds = Math.abs(seconds);
    token = 'from now';
    list_choice = 2;
  }
  var i = 0,
    format;
  while (format = time_formats[i++])
    if (seconds < format[0]) {
      if (typeof format[2] == 'string')
        return format[list_choice];
      else
        return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
    }
  return time;
})

Vue.directive('click-outside', {
  // When the bound element is inserted into the DOM...
  bind: function (el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== "function") {
      const compName = vNode.context.name;
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
      if (compName) {
        warn += `Found in component '${compName}'`;
      }

      console.warn(warn);
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble;
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;

    // add Event Listeners
    document.addEventListener("click", handler);
  },
  unbind: function (el, binding) {
    // Remove Event Listeners
    document.removeEventListener("click", el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
})

Vue.mixin(uimixin)

Vue.prototype.$helpers = helpers

new Vue({
  el: '#app',
  router,
  store,
  apolloProvider,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  template: '<App/>',
  components: {
    App
  },
  created() {
    this.$store.dispatch('currentUser')
  },
})
